(function () {
  const KEY = 'gclid_like';

  /* Hilfsfunktion: gclid ins Cart-Objekt pushen */
  async function saveCidToCart(cid) {
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({ attributes: { [KEY]: cid } })
    });
    /* UI auffrischen – Drawer & Counter aktualisieren */
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {bubbles: true}));
  }

  /* 1) Beim ersten Seitenaufruf prüfen, ob Attribut fehlt ------------- */
  const cidInitial = localStorage.getItem(KEY);
  if (cidInitial) {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        if (!cart.attributes || cart.attributes[KEY] !== cidInitial) saveCidToCart(cidInitial);
      });
  }

  /* 2) Danach jedes Mal, wenn Impact sein cart:change-Event schickt ---- */
  document.addEventListener('cart:change', ({ detail }) => {
    const cid = localStorage.getItem(KEY);
    if (!cid) return;
    const already = detail.cart.attributes && detail.cart.attributes[KEY];
    if (already !== cid) saveCidToCart(cid);
  });
})();